import { hash } from '@ember/helper';
import { service } from '@ember/service';

import { eq, not } from 'ember-truth-helpers';

import Component from 'umg-ember-backend/components/record-detail/forms';
import AssetPreview from 'umg-ember-backend/components/ui/asset-preview/index';
import Form from 'umg-ember-backend/components/ui/form';

export default class RecordDetailFormsCollection extends Component {
  // Services
  @service intl;

  // Getter and setter
  get collectionTypes() {
    const scope = 'forms.collection.options.type';

    return [
      {
        value: 'article',
        label: this.intl.t(`${scope}.article`),
        hasManyRelation: 'articles',
      },
      {
        value: 'theme',
        label: this.intl.t(`${scope}.theme`),
        hasManyRelation: 'artistTypes',
      },
      {
        value: 'photo',
        label: this.intl.t(`${scope}.photo`),
        hasManyRelation: 'assets',
        filters: {
          assetFolderId: '2',
        },
        options: {
          allowedFolder: '100',
        },
      },
      {
        value: 'date_live',
        label: this.intl.t(`${scope}.date_live`),
        hasManyRelation: 'liveEvents',
      },
      {
        value: 'label',
        label: this.intl.t(`${scope}.label`),
        hasManyRelation: 'labels',
      },
      {
        value: 'media_embed',
        label: this.intl.t(`${scope}.media_embed`),
        hasManyRelation: 'mediaEmbeds',
      },
      {
        value: 'date_media',
        label: this.intl.t(`${scope}.date_media`),
        hasManyRelation: 'mediaEvents',
      },
      {
        value: 'product',
        label: this.intl.t(`${scope}.product`),
        hasManyRelation: 'products',
      },
      {
        value: 'product_family',
        label: this.intl.t(`${scope}.product_family`),
        hasManyRelation: 'productFamilies',
      },
      {
        value: 'teaser',
        label: this.intl.t(`${scope}.teaser`),
        hasManyRelation: 'teasers',
      },
      {
        value: 'video',
        label: this.intl.t(`${scope}.video`),
        hasManyRelation: 'assets',
        filters: {
          assetFolderId: '11',
        },
        options: {
          allowedFolder: '101',
        },
      },
      {
        value: 'web_series',
        label: this.intl.t(`${scope}.web_series`),
        hasManyRelation: 'webSeries',
      },
    ];
  }

  get selectedType() {
    return this.collectionTypes.find(
      (collectionType) => collectionType.value === this.args.model?.type,
    );
  }

  // Functions
  selectType = (option) => {
    let currentSelectedType = this.selectedType;

    if (currentSelectedType) {
      this.args.model[currentSelectedType.hasManyRelation] = [];
    }
    this.args.model.type = option.value;
  };

  // Template
  <template>
    <Form @model={{@model}} @showErrors={{@showErrors}} as |form|>
      <div class='o-layout'>
        <div class='o-layout__item u-1/1 u-2/3@tablet'>
          <form.sections.variant
            @availableLanguages={{this.availableLanguages}}
          />

          <form.fieldset @titleKey='content' as |fieldset|>
            <fieldset.field @property='headline' />
            <fieldset.field @property='text' @type='text-editor' />

            <fieldset.field
              @property='type'
              @type='select-value'
              @disabled={{not @model.isNew}}
              @options={{this.collectionTypes}}
              @onChange={{this.selectType}}
            />

            {{#if this.selectedType}}
              <fieldset.field
                @filters={{this.selectedType.filters}}
                @options={{this.selectedType.options}}
                @property={{this.selectedType.hasManyRelation}}
                @type='has-many'
                @label={{this.selectedType.label}}
                as |record|
              >
                {{#if (eq this.selectedType.hasManyRelation 'assets')}}
                  <AssetPreview @asset={{record}} />
                {{else}}
                  {{record.displayLabel}}
                {{/if}}
              </fieldset.field>
            {{/if}}
          </form.fieldset>

          <form.sections.seo />
        </div>

        <div class='o-layout__item u-1/1 u-1/3@tablet'>
          <form.fieldset @titleKey='settings' as |fieldset|>
            <fieldset.field
              @property='cmsState'
              @type='select-value'
              @options={{this.cmsStateOptions}}
            />

            {{#if this.isParent}}
              <fieldset.field
                @property='cmsLanguageId'
                @type='select-value'
                @options={{this.availableLanguages}}
              />
            {{/if}}
          </form.fieldset>

          <form.fieldset @titleKey='assignments' as |fieldset|>
            <fieldset.field
              @property='artists'
              @type='has-many'
              @on={{hash openNewRecord=false}}
            />

            <fieldset.field
              @property='channelsAdditive'
              @type='has-many'
              @on={{hash openNewRecord=false}}
            />

            <fieldset.field
              @property='channelsExcluded'
              @type='has-many'
              @on={{hash openNewRecord=false}}
            />

            <fieldset.field
              @property='channelsExclusive'
              @type='has-many'
              @on={{hash openNewRecord=false}}
            />
          </form.fieldset>

          <form.sections.meta />
        </div>
      </div>
    </Form>
  </template>
}
